"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dropdown = _interopRequireDefault(require("@emcasa/ui-dom/components/Dropdown"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _Message = _interopRequireDefault(require("./Message"));

var _util = require("@google/maps/lib/util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ABORT_CONTROLLER_SUPPORT = process.browser && 'AbortController' in window;
var dropdownProps = ['height', 'hideTrailingIcon', 'leadingIconProps'];
var inputProps = ['height', 'placeholder'];

var GoogleMapsAutoComplete =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(GoogleMapsAutoComplete, _PureComponent);

  function GoogleMapsAutoComplete() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, GoogleMapsAutoComplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(GoogleMapsAutoComplete)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      predictions: [],
      focus: false,
      error: undefined,
      loading: false,
      value: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadPredictions", (0, _debounce["default"])(
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var _this$props, options, onLoadPredictions, _this$state, value, loading, endpoint, response, _ref2, _ref2$predictions, predictions;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, options = _this$props.options, onLoadPredictions = _this$props.onLoadPredictions;
              _this$state = _this.state, value = _this$state.value, loading = _this$state.loading;
              endpoint = _this.constructor.API_ENDPOINT;

              if (value) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              if (loading) _this.abort();else _this.setState({
                loading: true,
                error: undefined
              });
              _context.prev = 6;
              if (ABORT_CONTROLLER_SUPPORT) _this.fetchController = new AbortController();
              _context.next = 10;
              return window.fetch(_this.getUrl(), typeof options === 'function' ? options(_objectSpread({
                endpoint: endpoint
              }, _this.state)) : options);

            case 10:
              response = _context.sent;
              _context.next = 13;
              return response.json();

            case 13:
              _ref2 = _context.sent;
              _ref2$predictions = _ref2.predictions;
              predictions = _ref2$predictions === void 0 ? [] : _ref2$predictions;
              if (onLoadPredictions) onLoadPredictions(predictions, value);

              _this.setState({
                loading: false,
                predictions: predictions
              });

              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](6);

              _this.setState({
                loading: false,
                focused: true,
                error: _context.t0
              });

            case 23:
              _context.prev = 23;
              _this.fetchController = undefined;
              return _context.finish(23);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 20, 23, 26]]);
    })), 200));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "abort", function () {
      var loading = _this.state.loading;
      if (loading && _this.fetchController) _this.fetchController.abort();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reset", function () {
      return _this.setState({
        value: '',
        loading: false,
        error: undefined,
        predictions: []
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "blur", function () {
      return _this.setState({
        focused: false
      }, _this.props.onBlur);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
      return _this.setState({
        focused: true
      }, _this.props.onFocus);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeText", function (e) {
      var value = (0, _isObject["default"])(e) ? e.target.value : e;
      if (_this.props.onChangeText) _this.props.onChangeText(value);
      if (!_this.state.focused) _this.props.onFocus();

      _this.setState({
        value: value,
        focused: true
      }, _this.loadPredictions);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectPlace", function (placeId) {
      var place = _this.state.predictions.find(function (place) {
        return place.place_id === placeId;
      });

      if (!place) return;
      if (_this.props.onSelect) _this.props.onSelect(place);

      _this.setState({
        value: place.description
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(GoogleMapsAutoComplete, [{
    key: "getUrl",
    value: function getUrl() {
      var _this$props2 = this.props,
          apiUrl = _this$props2.apiUrl,
          sessionToken = _this$props2.sessionToken;
      var value = this.state.value;
      var endpoint = this.constructor.API_ENDPOINT;
      var queryString = "q=".concat(encodeURI(value), "&sessionToken=").concat(sessionToken);
      if (typeof apiUrl === 'function') return apiUrl(_objectSpread({
        sessionToken: sessionToken,
        endpoint: endpoint,
        queryString: queryString
      }, this.state));
      return "".concat(apiUrl, "/").concat(endpoint, "?").concat(queryString);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          renderLoading = _this$props3.renderLoading,
          renderEmpty = _this$props3.renderEmpty,
          renderPrediction = _this$props3.renderPrediction,
          renderControls = _this$props3.renderControls,
          props = (0, _objectWithoutProperties2["default"])(_this$props3, ["renderLoading", "renderEmpty", "renderPrediction", "renderControls"]);
      var _this$state2 = this.state,
          focused = _this$state2.focused,
          loading = _this$state2.loading,
          value = _this$state2.value,
          error = _this$state2.error,
          predictions = _this$state2.predictions;
      return _react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({
        focused: focused,
        inputProps: _objectSpread({
          ref: this.props.inputRef,
          autoComplete: "new-password",
          value: value,
          onChange: this.changeText
        }, (0, _pick["default"])(props, inputProps), {}, props.inputProps),
        onFocus: this.focus,
        onBlur: this.blur,
        onChange: this.selectPlace
      }, (0, _pick["default"])(props, dropdownProps)), error ? _react["default"].createElement(_Message["default"], {
        error: true
      }, error.message) : loading && !predictions.length ? renderLoading(this.state) : predictions && predictions.length ? predictions.map(renderPrediction) : renderEmpty(this.state));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return {
        focused: typeof props.focused !== 'undefined' ? props.focused : state.focused,
        error: typeof props.error !== 'undefined' ? props.error : state.error,
        predictions: props.predictions || state.predictions,
        value: props.value || state.value
      };
    }
  }]);
  return GoogleMapsAutoComplete;
}(_react.PureComponent);

exports["default"] = GoogleMapsAutoComplete;
(0, _defineProperty2["default"])(GoogleMapsAutoComplete, "API_ENDPOINT", 'autocomplete');
(0, _defineProperty2["default"])(GoogleMapsAutoComplete, "propTypes", {
  /** Base url where the maps middleware is mounted */
  apiUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,

  /** Fetch options */
  options: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,

  /** Dropdown height - BUTTON_HEIGHT from packages/ui/src/theme/measures.js */
  height: _propTypes["default"].string,

  /** Dropdown container props */
  containerProps: _propTypes["default"].object,

  /** Input component props */
  inputProps: _propTypes["default"].object,

  /** Render dropdown content when predictions are loading */
  renderLoading: _propTypes["default"].func,

  /** Render dropdown content for empty results */
  renderEmpty: _propTypes["default"].func,

  /** Render prediction dropdown option */
  renderPrediction: _propTypes["default"].func.isRequired,

  /** Render components to the right side of the input */
  renderControls: _propTypes["default"].func,

  /** Input blur event */
  onBlur: _propTypes["default"].func,

  /** Input focus event */
  onFocus: _propTypes["default"].func,

  /** Input onChange event */
  onChangeText: _propTypes["default"].func,

  /** Called place predictions are loaded */
  onLoadPredictions: _propTypes["default"].func,

  /** Called when a place is selected from the dropdown */
  onSelect: _propTypes["default"].func,

  /** Input component ref */
  inputRef: _propTypes["default"].any
});
(0, _defineProperty2["default"])(GoogleMapsAutoComplete, "defaultProps", {
  apiUrl: '/maps',
  options: {
    mode: 'same-origin'
  },
  height: 'medium',
  hideTrailingIcon: true,
  leadingIconProps: {
    name: 'map-marker-alt',
    color: 'grey300'
  },
  inputProps: {},
  renderLoading: function renderLoading() {
    return _react["default"].createElement(_Spinner["default"], null);
  },
  renderEmpty: function renderEmpty(_ref3) {
    var value = _ref3.value;
    return _react["default"].createElement(_Message["default"], null, value ? 'Endereço não encontrado. Tente outros termos.' : 'Digite um endereço para buscar.');
  },
  renderPrediction: function renderPrediction(_ref4) {
    var description = _ref4.description,
        place_id = _ref4.place_id;
    return _react["default"].createElement(_Dropdown["default"].Option, {
      key: place_id,
      value: place_id,
      iconProps: {
        name: 'map-marker-alt',
        color: 'grey300'
      }
    }, description);
  },
  sessionToken: (0, _util.placesAutoCompleteSessionToken)(),

  get inputRef() {
    return _react["default"].createRef();
  }

});